module.exports = __webpack_public_path__ + "static/theme-editor-show-welcome-text-8f5ba393ca38bd3d3f58eaecdfe4dcf6.png";